import React,{useState,useRef} from 'react';
import Container from "../Container";
import Heading from "../Heading";
import Card from "./Card";
import { useInView } from 'react-intersection-observer';


const Stats = () => {
    //const counterRow = useRef(null);
    //const counterOn = useOnScreen(counterRow)
    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
    });

    const cards = [
        {
            id:"1",
            counterNumber:"150",
            description:"Datcom’s average customer satisfaction score out of 5 (Datcom, 2022)"
        },
        {
            id:"2",
            counterNumber:"200",
            description:"Portion of companies that experienced 21-40 security incidents in 2022 (Fortinet, 2022)"
        },
        {
            id:"3",
            counterNumber:"350",
            description:"Total cost of ransomware payments globally (IBM, 2020)"
        },
        {
            id:"4",
            counterNumber:"450",
            description:"Average cost of a data breach in Australia (IBM, 2022)"
        },
        {
            id:"5",
            counterNumber:"221",
            description:"Average time to detect a breach in Australia (IBM, 2022)"
        },
        {
            id:"6",
            counterNumber:"598",
            description:"Annual cost of ransomware to the Australian economy (APH, 2021)"
        },
        {
            id:"7",
            counterNumber:"232",
            description:"Global average cost of resolving insider threats within a 12-month period (Fortinet, 2022)"
        },
        {
            id:"8",
            counterNumber:"85",
            description:"Average time to contain an insider threat globally (Ponemon Institute, 2022)"
        }
    ]

    return (
        <section className="py-5 bg-secondary-black">
            <Container className="py-0 py-lg-4">
                <div className="row">
                    <div className="col-12">
                        <Heading 
                            heading={'Stats that speak loud'}
                        />
                    </div>
                </div>
                {cards.length > 0 &&
                    <div  ref={ref}>
                        {inView &&
                            <div className='row mt-4 mt-lg-5'>
                                {cards.map((item) =>
                                    <Card 
                                        key={item.id}
                                        counterOn={inView}
                                        counterNumber={item.counterNumber}              
                                        description={item.description}
                                    />
                                )}
                            </div>
                        }
                    </div>                  
                }                    
            </Container>
        </section>
    );
};

export default Stats;